export default () => {
    if(window.document.documentMode) {
        $('#browser').show();
        $('body').addClass('overflow-hidden')
        console.log('browser')
    }
}